import React, {useCallback} from 'react';
import {useParams} from 'react-router';

import Filters from './filtersHeader';
import Posts from './posts';
import CustomBottomSheet from 'components/bottomSheet';
import SortForm from './filtersForms/sortForm';
import FilterForm from './filtersForms/filterForm';
import SearchInput from 'components/searchInput';
import useDebounce from 'utilities/hooks/debounce/useDebounce';
import SideBar from 'components/sidebar';
import SideBarMenu from 'modules/home/sadebarMenu';
import useHandleState from './hooks/useHandleState';
import useGetHotAuctionPostList from './hooks/useGetHotAuctionpostList';

interface AddsProps {
  app: 'farm' | 'market';
}
const HotAuctionAdds = ({app}: AddsProps) => {
  const {guid} = useParams();
  const {
    isSortOpen,
    isFilterOpens,
    filterFields,
    sortFilter,
    search,
    setIsSortOpen,
    setisFilterOpens,
    setfilterFields,
    setsortFilter,
    setSearch,
  } = useHandleState();

  const newSearch = useDebounce(search, 500);

  const {postListData, isLoading, fetchNextPage} = useGetHotAuctionPostList({
    product_category_guid: guid && guid,
    app: app,
    order_by: sortFilter,
    search: newSearch,
    ...filterFields,
  });
  const onWatchEnd = useCallback(() => {
    fetchNextPage();
  }, [fetchNextPage]);

  return (
    <>
      <div className="w-full h-full flex flex-col px-2 relative">
        <div className="w-full">
          <SideBar title="دسته‌بندی محصولات">
            <SideBarMenu />
          </SideBar>
        </div>
        <div className="w-full lex-col sticky top-0 z-20 bg-gray-10 rounded-xl mb-2">
          <div className="w-full mt-4">
            <SearchInput Search={search} setSearch={setSearch} />
          </div>
          <div className="w-full mt-4 mb-2">
            <Filters
              title="آگهی ها"
              isSortOpen={isSortOpen}
              isFilterOpens={isFilterOpens}
              setIsSortOpen={setIsSortOpen}
              setisFilterOpens={setisFilterOpens}
              sortFilter={sortFilter}
            />
          </div>
        </div>
        <div className="flex flex-col w-full gap-6">
          <Posts
            onWatchEnd={onWatchEnd}
            isloading={isLoading}
            posts={postListData?.pages.flatMap(x => x.results) || []}
            app={app}
          />
        </div>
      </div>
      <CustomBottomSheet
        isOpen={isSortOpen}
        onDismiss={() => setIsSortOpen(false)}
      >
        <SortForm
          setsortFilter={setsortFilter}
          sortFilter={sortFilter}
          setIsSortOpen={setIsSortOpen}
        />
      </CustomBottomSheet>
      <CustomBottomSheet
        isOpen={isFilterOpens}
        onDismiss={() => setisFilterOpens(false)}
      >
        <FilterForm
          filterFields={filterFields}
          onclose={setisFilterOpens}
          setFilter={setfilterFields}
        />
      </CustomBottomSheet>
    </>
  );
};

export default HotAuctionAdds;
